<template>
	<div class="w1200 flex myinfo">
		<choice-menu></choice-menu>
		<div class="flex flex-direction align-stretch benben-flex-layout myinfo_1">
			<div class="myinfo_2">{{$t('预约')}}</div>
			<div class="flex appointment_1">
				<template v-for="(item,index) in tim_list">
					<div @click="qiehuan(item)" :class="tab_1 == item.date ? 'appointment_1_2' : 'appointment_1_1'" class=" pointer">
					{{item.date_text}}({{item.week}})
					</div>
				</template>
			</div>
			<div v-loading="loading"  :element-loading-text="$t('拼命加载中')">
				<div class="" v-if="orde_list.length > 0">
					<template v-for="(item,index) in orde_list">
						<div class="flex flex-direction align-stretch benben-flex-layout pointer appointment_2" @click="caozuo(1,item)">
							<div class="flex appointment_3">
								<div class="flex appointment_3_1">{{item.address_ifno.address}}{{item.address_ifno.detail}}</div>
								<div class="flex appointment_3_2" v-if=" item.status=='delivery'">{{$t('配送中')}}</div>
								<div class="flex appointment_3_2" v-if=" item.status=='sending'">{{$t('待配送')}}</div>
							</div>
							<template v-for='(child,key1) in item.chlid'>
								<div class="flex appointment_4">
									<img class="appointment_4_1" :src="child.thumb" alt="" srcset="">
									<div class="flex-sub flex flex-direction align-stretch justify-between benben-flex-layout appointment_4_2">
										<div class="appointment_4_3">{{child.name}}</div>
										<div class="appointment_4_4">{{child.num}}{{$t('份')}}</div>
										
									</div>
								</div>
							</template>
							
						</div>
					</template>
				</div>
				<div class="myinfo_7 flex flex-direction flex-wrap align-center benben-flex-layout" v-else>
					<img class="myinfo_7_1" src="https://api.ezlunch.club/pc/image/29.png" alt="" srcset="">
					<div class="myinfo_7_2">{{$t('暂无预约')}}</div>
					<div class="myinfo_7_3 pointer">{{$t('预订更多')}}</div>
				</div>
				<div v-if="orde_list.length > 0" style="text-align: center;margin: 20px  0;">
					<el-pagination
					   @current-change="handleCurrentChange"
					   layout="prev, pager, next"
					   :current-page.sync="page" :page-size="page_size"
					   :total="total">
					 </el-pagination>
				</div>
			</div>
			
			
		</div>
		
	</div>
</template>

<script>
	import ChoiceMenu from "../components/choiceMenu.vue"
	export default {
		components: {
			ChoiceMenu
		},
		data() {
			return {
				total:0,
				page:1,
				page_size:10,
				loading:true,
				tim_list:[],
				orde_list:[],
				tab_1:'',
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				this.post68db409061aa4()
			}else{
				this.$router.push({
					name: 'login',
				});
			}
			
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post68db409061aa4()
			},
			qiehuan(item){
				this.loading = true
				this.tab_1 = item.date
				this.page = 1
				this.post68db3e68c732a()
			},
			
			// 查询套餐订单预约时间列表
			post68db409061aa4(){
				this.$api.post(this.$apiUrls.post68db409061aa4).then((res) => {
					if(res.code == 1){
						this.tim_list = res.data
						if(!this.tab_1){
							this.tab_1 = this.tim_list[0].date
						}
						this.post68db3e68c732a()
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 切换页面
			handleCurrentChange(val){
				this.page = val
				this.post68db3e68c732a()
			},
			// 查询配送中套餐订单列表
			post68db3e68c732a(){
				this.$api.post(this.$apiUrls.post68db3e68c732a,{page:this.page,list_rows:this.page_size,date:this.tab_1}).then((res) => {
					if(res.code == 1){
						this.orde_list = res.data.data
						this.total = res.data.total
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type,item){
				let url = ''
				if(type == 1){
					url = 'orderDetal'
					window.sessionStorage.setItem('order_type',2);
					window.sessionStorage.setItem('order_id', item.aid);
				}
				this.$router.push({
					name: url,
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.myinfo{
		margin-top: 20px;
	}
	.myinfo_1{
		width: 980px;
		margin: 0 0 0 220px;
		padding:0 20px 100px;
		background: #fff;
		box-sizing: border-box;
	}
	.myinfo_2{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.appointment_1{
		width: 786px;
		height: 38px;
		border: 1px solid #CCCCCC;
		border-radius: 4px;
		margin: 16px 0 0;
        // overflow-x: auto; /* 横向滚动 */
	
	}
	
	.appointment_1_1{
		border-radius: 0px 0px 0px 0px;
		border-right: 1px solid #CCCCCC;
		width: 111px;
		height: 37px;
		text-align: center;
		line-height: 37px;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		display: inline-block;
	}
	.appointment_1_2{
		border-radius: 0px 0px 0px 0px;
		border-right: 1px solid #FF770F;
		width: 111px;
		height: 37px;
		text-align: center;
		line-height: 37px;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		background: #FF770F;
	}
	.appointment_2{
		background: #F8F8FA;
		border-radius: 8px 8px 8px 8px;
		padding: 0 16px 16px;
		margin: 20px 0 0 0;
		width: 786px;
	}
	.appointment_3{
		padding: 16px 0 10px 0;
		border-bottom: 1px solid #E7E7E7;
	}
	.appointment_3_1{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	.appointment_3_2{
		font-weight: 400;
		font-size: 14px;
		color: #FF770F;
		margin: 0 0 0 auto;
	}
	.appointment_4{
		margin: 16px 0 0 0;
	}
	.appointment_4_1{
		width: 96px;
		height: 96px;
	}
	.appointment_4_2{
		margin: 0 0 0 12px;
		height: 96px;
	}
	.appointment_4_3{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.appointment_4_4{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
		// margin: auto 0 0 0;
	}
	.myinfo_7{
		padding: 72px 0;
	}
	.myinfo_7_1{
		width: 217px;
		height: 177px;
	}
	.myinfo_7_2{
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}
	.myinfo_7_3{
		height: 42px;
		background: #FF8A24;
		border-radius: 6px 6px 6px 6px;
		padding: 0 38px;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 42px;
		margin: 39px 0 0 0;
	}
</style>